// extracted by mini-css-extract-plugin
export default {"wrap":"LF-z","fullWidth":"MF-z","hideOnDesktop":"NF-z","content":"OF-z","hasOpenedNav":"PF-z","crumbsList":"QF-z","dropdownsWrap":"RF-z"};